<template>
    <button 
        class="btn" 
        :class="['btn-' + variant, 'btn-' + size, { 'btn-block': block }, 'text-' + white, { 'btn-disabled': disabled }]"
        :type="type" :disabled="disabled"
        :style="disabled ? { backgroundColor: '#2f2f2f', color: 'white' } : {}"
    ><slot/></button>
</template>
<script>
export default {
    props:{
        variant: {
            type: String,
            default: 'primary',
        },
        white: {
            type: String,
            default: ''
        },
        id: {
            type: String,
        },
        name: {
            type: String,
        },
        size: {
            type: String,
            default: ''
        },
        block: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        lg: {
            type: String,
            default: ''
        },
    },
    name:"OButton"
}
</script>
<style scoped>
.btn-disabled {
    background-color: #2f2f2f !important; /* Grayscale black */
    color: white !important;
    cursor: not-allowed;
}
.btn-info {
    background-color: #007bff !important; 
    color: white !important;
    border: 1px solid #007bff !important;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}
.btn-info:hover {
    background-color: #007bff !important;
    border-color: #007bff !important;
}

/* Dynamic Theme Support for Primary Button */
.btn-primary {
    background-color: var(--primary-color, #F93E3E) !important;
    border-color: var(--primary-color, #F93E3E) !important;
    color: #ffffff !important;
    transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
    filter: brightness(0.9) !important;
    color: #ffffff !important;
}

.btn-secondary {
    background-color: var(--secondary-color, #FEE9E9) !important;
    border-color: var(--secondary-color, #FEE9E9) !important;
    color: var(--primary-color, #F93E3E) !important;
    transition: all 0.2s ease;
}

.btn-secondary:hover:not(:disabled) {
    border-color: var(--primary-color, #F93E3E) !important;
    filter: brightness(0.95) !important;
    color: var(--primary-color, #F93E3E) !important;
}

.btn-outline-secondary {
    background-color: #ffffff !important;
    border: 1px solid var(--primary-border, #F93E3E) !important;
    color: var(--primary-color, #F93E3E) !important;
    transition: all 0.2s ease;
}

.btn-outline-secondary:hover:not(:disabled) {
    background-color: var(--secondary-color, #FEE9E9) !important;
    border-color: var(--primary-border, #F93E3E) !important;
    color: var(--primary-color, #F93E3E) !important;
}
</style>